import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "SelectScreenItem",
  props: {
    index: {
      type: String,
      default: "0"
    },
    label: {
      type: String,
      default: ""
    }
  }
});